import type { CSSProperties } from 'react';

interface CheckboxProps {
  checked?: boolean;
  label?: string;
  className?: string;
  style?: CSSProperties;
}

export function CheckboxView({ checked = false, label, className, style }: CheckboxProps) {
  return (
    <label
      className={`flex items-center gap-2 text-sm text-zinc-700 dark:text-zinc-300${className ? ` ${className}` : ''}`}
      style={style}
    >
      <input
        type="checkbox"
        checked={checked}
        readOnly
        className="h-4 w-4 rounded border-zinc-300"
      />
      {label && <span>{label}</span>}
    </label>
  );
}
